import { render, staticRenderFns } from "./ListadoConvenios.vue?vue&type=template&id=dd663916"
import script from "./ListadoConvenios.vue?vue&type=script&lang=js"
export * from "./ListadoConvenios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports